var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.998 0A.995.995 0 0 1 12 .998v6.146c0 .552-.316 1.315-.707 1.706L8.85 11.293c-.39.39-1.145.707-1.706.707H.998C.447 12 0 11.544 0 10.998V1.002C0 .45.456 0 1.002 0zM11 6H8.005A2.003 2.003 0 0 0 6 8.005V11h1V8.01C7 7.451 7.443 7 8.01 7H11z"
})));
export default SvgNote;